module.exports = __webpack_public_path__ + "media/images/smart_phone/kutikomi/star-f2d3acc9855ceff7c5f1adbed2adb1e3.png";